




import React from "react";
import {
  FaAngleLeft,
  FaAngleRight,
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
} from "react-icons/fa";

const Pagination = ({ currentPage, totalPages, onPageChange ,showFirstLast = true}) => {
  // Safety checks
  const safeTotalPages = Math.max(totalPages || 1, 1);
  const safeCurrentPage = Math.min(Math.max(currentPage || 1, 1), safeTotalPages);
  
  const handlePageChange = (page) => {
    // Ensure page is within valid range
    const validPage = Math.min(Math.max(page, 1), safeTotalPages);
    if (validPage !== safeCurrentPage) {
      onPageChange(validPage);
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const startPage = Math.max(safeCurrentPage - 1, 1);
    const endPage = Math.min(safeCurrentPage + 1, safeTotalPages);

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={`mx-1 rounded-md border px-3 py-1 sm:px-4 sm:py-2 text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-[#c51369] ${
            safeCurrentPage === i
              ? "bg-gray-200 font-bold text-navy-700 ring-1 ring-[#c51369]"
              : ""
          }`}
        >
          {i}
        </button>
      );
    }
    return pageNumbers;
  };

  // Don't render pagination if there's only one page or no pages
  if (safeTotalPages <= 1) {
    return null;
  }

  return (
    <div className="mt-4 flex flex-wrap justify-center items-center mb-5">
      {/* First */}

      {showFirstLast && (

        <button
        onClick={() => handlePageChange(1)}
        disabled={safeCurrentPage === 1}
        className="mx-1 flex items-center gap-1 rounded-md border bg-white px-2 py-1 sm:px-4 sm:py-2 text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-[#c51369] disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <FaAngleDoubleLeft />
        <span className="hidden sm:inline">First</span>
      </button>
      )}
      

      {/* Previous */}
      <button
        onClick={() => handlePageChange(safeCurrentPage - 1)}
        disabled={safeCurrentPage === 1}
        className="mx-1 flex items-center gap-1 rounded-md border bg-white px-2 py-1 sm:px-4 sm:py-2 text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-[#c51369] disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <FaAngleLeft />
        <span className="hidden sm:inline">Previous</span>
      </button>

      {/* Page numbers */}
      {renderPageNumbers()}

      {/* Next */}
      <button
        onClick={() => handlePageChange(safeCurrentPage + 1)}
        disabled={safeCurrentPage === safeTotalPages}
        className="mx-1 flex items-center gap-1 rounded-md border bg-white px-2 py-1 sm:px-4 sm:py-2 text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-[#c51369] disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <span className="hidden sm:inline">Next</span>
        <FaAngleRight />
      </button>

      {/* Last */}

      {showFirstLast && (
        <button
        onClick={() => handlePageChange(safeTotalPages)}
        disabled={safeCurrentPage === safeTotalPages}
        className="mx-1 flex items-center gap-1 rounded-md border bg-white px-2 py-1 sm:px-4 sm:py-2 text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-[#c51369] disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <span className="hidden sm:inline">Last</span>
        <FaAngleDoubleRight />
      </button>
      )}
      
    </div>
  );
};

export default Pagination;